
















import Vue from 'vue'
// @ts-ignore
import VueQr from 'vue-qr'
import infoBlock from 'src/components/InfoBlock/InfoBlock.vue'
export default Vue.extend({
  name: 'qrcode',
  components: {
    VueQr,
    infoBlock
  },
  data () {
    return {
      stringToEncode: null as null | string
    };
  },
  mounted () {
    this.stringToEncode = window.location.href;
  },
  methods: {
    onCodeGenerate (dataUrl: any, id: any) {
      // @ts-ignore
      this.$bus.$emit('qrcode:generated', dataUrl);
    }
  }
})
